import ROUTES from "./routes";
import type { AxiosPromise } from "axios";
import type { AuthUserShowResponse } from "@/api/modules/authUser/types";
import { apiClient } from "@/api/modules/base";

/**
 * @namespace authUser
 */

/**
 * Retrieve auth user data
 *
 * @method
 * @memberOf authUser
 * @author Dominik Niemann <dominikniemann@posteo.de>
 */
export const show = (): AxiosPromise<AuthUserShowResponse> => apiClient.get(ROUTES.AUTH_USER.SHOW);
